import { VariantProps } from 'class-variance-authority'
import { Link, LinkProps } from 'react-router-dom'
import { buttonVariants } from './button'
import Card from 'app/frontend/base/components/Card'
import { cn } from '@/lib/utils'

type Props = LinkProps & Omit<VariantProps<typeof buttonVariants>, 'variant'>

const LinkButton = ({ children, className, size, ...props }: Props) => {
  return (
    <Link {...props}>
      <Card
        className={cn(buttonVariants({ variant: 'outline', size }), className)}
      >
        {children}
      </Card>
    </Link>
  )
}

export default LinkButton
